import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Home from './views/home'
import AboutClementineStory from './views/about-clementine-story'
import BookACallContact from './views/book-a-call-contact'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route
          component={AboutClementineStory}
          exact
          path="/about-clementine-story"
        />
        <Route component={BookACallContact} exact path="/book-a-call-contact" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))

// FORM_HANDLER
const INTAKE_ENDPOINT = 'https://makersconsulting.com/api/intake'
const SOURCE_SITE = window.location.hostname

const normalizeKey = (key) => key.toLowerCase().replace(/[^a-z0-9]/g, '')

const findFieldValue = (data, keywords) => {
  const keys = Object.keys(data)
  for (const key of keys) {
    const normalized = normalizeKey(key)
    if (keywords.some((kw) => normalized.includes(kw))) {
      const value = data[key]
      if (typeof value === 'string' && value.trim().length > 0) {
        return value.trim()
      }
    }
  }
  return ''
}

const extractFormData = (form) => {
  const formData = new FormData(form)
  const data = {}
  formData.forEach((value, key) => {
    if (typeof value === 'string') {
      data[key] = value.trim()
    }
  })
  return data
}

const showFormStatus = (form, type, message) => {
  let status = form.querySelector('.form-status')
  if (!status) {
    status = document.createElement('div')
    status.className = 'form-status'
    form.appendChild(status)
  }
  status.classList.remove('success', 'error')
  status.classList.add(type)
  status.textContent = message
}

const isLikelyContactForm = (form) => {
  if (form.dataset.formId) return true
  if (form.querySelector('input[type="email"]')) return true
  if (form.querySelector('textarea')) return true
  return false
}

const attachFormHandlers = () => {
  document.querySelectorAll('form').forEach((form) => {
    if (!isLikelyContactForm(form)) return
    if (form.dataset.intakeBound === 'true') return
    form.dataset.intakeBound = 'true'

    form.addEventListener('submit', async (event) => {
      event.preventDefault()

      const data = extractFormData(form)
      const email = findFieldValue(data, ['email'])
      const name = findFieldValue(data, ['fullname', 'firstname', 'lastname', 'name'])
      const message =
        findFieldValue(data, ['message', 'description', 'details', 'summary', 'request', 'project']) ||
        ''

      const conversionType = form.dataset.conversionType || 'contact_form_submission'

      const payload = {
        email,
        sourceSite: SOURCE_SITE,
        conversionType,
        message,
        details: {
          ...data,
          fullName: name,
          pageUrl: window.location.href,
          referrer: document.referrer,
        },
      }

      const submitButton = form.querySelector('button[type="submit"], input[type="submit"]')
      const originalText = submitButton ? submitButton.textContent : null
      if (submitButton) {
        submitButton.disabled = true
        submitButton.textContent = 'Sending...'
      }

      try {
        const response = await fetch(INTAKE_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        })

        if (!response.ok) {
          throw new Error(`Request failed (HTTP ${response.status})`)
        }

        showFormStatus(form, 'success', 'Thanks! We received your message.')
        form.reset()
      } catch (error) {
        showFormStatus(
          form,
          'error',
          'Sorry, there was an issue sending your request. Please email us directly.'
        )
        console.error('Form submission failed:', error)
      } finally {
        if (submitButton) {
          submitButton.disabled = false
          submitButton.textContent = originalText || 'Submit'
        }
      }
    })
  })
}

window.addEventListener('load', attachFormHandlers)
